import { NoMediaHeroSection } from '@website/cms';
import { NoMediaHeroSectionModel } from './no-media-hero-section.model';

export const getNoMediaHeroSection = (section: NoMediaHeroSection): NoMediaHeroSectionModel => ({
  navTitle: section.navTitle,
  title: section.title,
  description: section.description || '',
});
